import React, { useCallback, useMemo, useState } from "react";
import { Button, Textarea } from "@shared/components";
import { StationIssue } from "@shared/models";
import { getFormattedDate, getFullName } from "@shared/utils";
import { DATE_FORMAT_TYPE } from "@shared/interfaces";

import "./index.scss";

interface StationIssuesConfirmModalProps {
  issue: StationIssue;
  onClose: () => void;
  onSuccess: (comment: string | null) => void;
}

const StationIssuesConfirmModal = (props: StationIssuesConfirmModalProps) => {
  const { onClose, onSuccess, issue } = props;
  const [comment, setComment] = useState<string | null>(null);

  const isActiveSubmitButton = useMemo(() => {
    const MIN_CHARS = 5;
    return comment && comment.length >= MIN_CHARS;
  }, [comment]);

  const handleCommentChange = useCallback((event: React.FormEvent<HTMLTextAreaElement>) => {
    setComment((event.target as any).value);
  }, []);

  return (
    <div className="station-issue-read-confirm modal-content-wrapper">
      <div className="modal-heading">Mark As Read</div>
      <div>
        <div className="modal-content">
          <div className="sdh-issue-info">
            <div>
              <div className="sdh-issue-row-name">{getFullName(issue.patient)}</div>
              <div className="sdh-issue-row-code">{issue.station.station_code}</div>
            </div>
            <div>
              <div className="sdh-issue-reason">{issue.issue}</div>
              <div className="sdh-issue-date">Since {getFormattedDate(issue.issue_date, DATE_FORMAT_TYPE.SHORT)}</div>
            </div>
          </div>
          <div className="form-rows">
            <div className="title-column">
              <Textarea
                type="text"
                labelTitle={""}
                name="comment"
                onChange={handleCommentChange}
                maxLength={500}
                placeholder="Please add the actions you did before closing this notification"
                cols={1}
              />
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            disabled={!isActiveSubmitButton}
            className="blue auto-width"
            onClick={onSuccess.bind(null, comment)}
          >
            Mark As Read
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StationIssuesConfirmModal;
